var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mmain"},[_c('div',{staticClass:"wrapper"},[_c('mNewsList',{attrs:{"fenlei":"政策法规"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }